import stbAPIGateway from '../../../../services/stbAPIGateway';

export const getCsvZipHubUploadBatchList = async ({ rootGetters, commit }, { clientSid }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const response = await stbApi.getCsvZipHubUploadBatchList({}, clientSid);
  commit('setBatchList', response.batchSummaries || []);
  return response;
};
